import { SOCIAL_ACCOUNT_KEYS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';

export const syncSocialChannelsV1RequestSchema = z.object({
  provider: z.enum(SOCIAL_PROVIDERS),
  // Which aggregator account to sync; defaults to 'default' server-side.
  accountKey: z.enum(SOCIAL_ACCOUNT_KEYS).optional(),
});

export type ISyncSocialChannelsV1Request = z.infer<typeof syncSocialChannelsV1RequestSchema>;
